(ns quuppa.common.qpe.schema
  (:require [clojure.string :as str]))


(def ->lower-case (comp str/lower-case name))

(def ->lower-case-keyword
  "Converts keyword or string to lower-cased keyword"
  (comp keyword ->lower-case))

(def ^:private simple-string-pattern #"[A-Za-z0-9\-\_]+")
(def simple-string?
  [:re {:error/message "Only alphanumeric characters, hyphen and underscore are valid"
        :json-schema/type "string"
        ;; TODO check if this is ECMA regex valid?
        ;; ....string SHOULD be a valid regular expression, according to the ECMA-262 regular expression dialect.
        :json-schema/pattern "[A-Za-z0-9\\-\\_]+"}
   simple-string-pattern])
